import React from 'react';
import '../../style/dots.css';
import '../../style/solicitorGroupList.css'
import SolicitorGroupHOC from '../../containers/SolicitorGroups/solicitorGroupHOC'
import Button from "../button";
import {LEGAL_ADVICE_TEXT, UI_LIB_TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import {Table, FormGroup, List} from 'arag-ui-lib';
import CustomModal from "../General/customModal";
import {FORM_GROUP_VARIANTS} from "../../helpers/formGroupVariants";
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { goAtPrevious, goAtNext, goAtStart, goAtEnd, goAtPage, formatSolicitorTableLabel, formatSolicitorOptionLabel } from '../../helpers/functions';
import { INPUT_CHANGE } from '../../helpers/constants';

const columns = [
	{
		propertyName: "name",
		header: CONTENT_STRINGS.NAME,
		formatter: (row) => formatSolicitorTableLabel({ label: row.name, aragProvider: row.aragProvider })
	},
	{
		propertyName: "underwriterName",
		header: CONTENT_STRINGS.CAPACITY_UNDERWRITER,
		formatter: (row) => (
			<List items={row.underwriterNames.map((uw) => ({ content: uw }))} variant={FORM_GROUP_VARIANTS.PLAIN}/>
		)
	},
	{
		propertyName: "solicitors",
		header: `${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRMS}`,
		formatter: (datum) => (
			<List
				items={datum.solicitors.map((s) => ({
					content: formatSolicitorTableLabel({ label: s.lawsysFirm, aragProvider: s.aragProvider })
				}))}
				variant={FORM_GROUP_VARIANTS.PLAIN}
			/>
		)
	},
	{
		propertyName: "workSources",
		header: CONTENT_STRINGS.WORK_SOURCES,
		formatter: (datum) => (
			<List items={datum.workSourceNames.map((ws) => ({ content: ws }))} variant={FORM_GROUP_VARIANTS.PLAIN}/>
		)
	}
];

const SolicitorGroupList = (props) => {
	const handlePageChange = (page) => props.changeSolicitorGroupListSettings('page', page);

	const searchOptions = (props.store.suggestions || []).map(group => ({
		value: group.id,
		label: group.name,
		aragProvider: group.aragProvider,
		data: group
	}));

	const onInputChange = (newValue, actionMeta) => {
		if (actionMeta.action !== INPUT_CHANGE) return;
		props.changeSolicitorGroupListSettings('value', newValue);
		if (newValue === '') {
			props.changeSolicitorGroupListSettings('selectedSuggestions', props.store.solicitorGroups);
		}
	};

	const onGroupSelected = (selectedOption) => {
		if (!selectedOption) return;
		props.onSuggestionSelected({}, {suggestion: selectedOption.data, method: 'click'});
	};

	const onPageSizeChange = (evt) => props.changeSolicitorGroupListSettings('selectedView', evt.target.value);

	const prevPage = goAtPrevious(handlePageChange, props.store.page);
	const nextPage = goAtNext(handlePageChange, props.store.page, props.store.totalBoxes);
	const firstPage = goAtStart(handlePageChange);
	const lastPage = goAtEnd(handlePageChange, props.store.totalBoxes);
	const selectPage = goAtPage(handlePageChange);

	return (
		<div className="row solicitorGroupList-wrapper">
			<div className="col-sm-12">
				<CustomModal
					isOpen={props.store.openModal}
					handleClose={() => props.changeSolicitorGroupListSettings('openModal', false)}
					content={<SolicitorGroupHOC/>}
					contentClassname={"solicitorGroupList-modal"}
				/>
				<div className="row">
					<h2 className="col-sm-12 applicationsAndPolicies-h2">{`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}s`}</h2>
				</div>
				<form className="form-horizontal" onSubmit={evt => { evt.preventDefault(); props.handleAutosuggestButton(); }}>
					<div className="form-group">
						<div className="col-md-9">
							<FormGroup
								labelSize={"col-sm-2"}
								inputSize={"col-sm-10"}
								label={CONTENT_STRINGS.SEARCH}
								variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
								inputProps={{
									instanceId: 'solicitorGroupsSearch',
									options: searchOptions,
									onChange: onGroupSelected,
									onInputChange: onInputChange,
									inputValue: props.store.value,
									value: null,
									placeholder: CONTENT_STRINGS.SEARCH,
									noOptionsText: CONTENT_STRINGS.NO_RESULTS_FOUND,
									onSearchIconClick: props.handleAutosuggestButton,
									filterOption: () => true,
									formatOptionLabel: formatSolicitorOptionLabel,
								}}
								// formGroupTestId={""}
							/>
						</div>
						<div className="col-md-3">
							<Button wrapper={"btn-wrapper"} clickHandler={() => props.changeSolicitorGroupListSettings('openModal', true)} btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'} label={`${CONTENT_STRINGS.CREATE} ${CONTENT_STRINGS.NEW} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}/>
						</div>
					</div>
				</form>
				<Table
					loading={props.store.fetching}
					columns={columns}
					data={props.store.solicitorGroups || []}
					responsive
					striped
					hasActions
					actions={[
						{
							key: 'details',
							label: CONTENT_STRINGS.DETAILS,
							callback: (row) => {
								props.changeSolicitorGroupListSettings('selectedGroup', row);
								props.push('/solicitors/solicitor-groups/edit-solicitor-group/' + row.id);
							}
						},
					]}
					accordionItemHeaderFormatter={(row) => `${CONTENT_STRINGS.NAME}: ${row.name}`}
					page={props.store.page}
					pageSize={parseInt(props.store.selectedView)}
					totalRecords={props.store.totalRecords}
					totalPages={props.store.totalBoxes}
					pageSizeOptions={UI_LIB_TABLE_VIEW_OPTIONS}
					onPageSizeChange={onPageSizeChange}
					goAtPrevious={prevPage}
					goAtNext={nextPage}
					goAtStart={firstPage}
					goAtEnd={lastPage}
					goAtPage={selectPage}
					noResultsMessage={`${CONTENT_STRINGS.NO} ${LEGAL_ADVICE_TEXT.toLowerCase()} ${CONTENT_STRINGS.GROUPS_TO_SHOW}`}
					// tableWrapperTestId={""}
				/>
			</div>
		</div>
	)
};

export default SolicitorGroupList;
